import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MY_OWN_FILTER } from '../constants/constants';
import { SelectFilters } from '../components/searchableSelect/searchableSelectTypes';

/** The My own tag `SearchableSelect` shows for a list that has an endpoint for it, removed like the picker page's. */
export const useOwnerSelectFilter = () => {
  const { t } = useTranslation();
  const [isMyOwn, setIsMyOwn] = useState(true);
  const clearOwnerFilter = () => setIsMyOwn(false);

  const filters: SelectFilters = {
    applied: isMyOwn ? [{ value: MY_OWN_FILTER, label: t('common:ownerFilter.myOwn') }] : [],
    onRemove: clearOwnerFilter,
    onClearAll: clearOwnerFilter,
  };

  return { isMyOwn, filters };
};
